import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-alert',
  templateUrl: './dialog-alert.component.html',
  styleUrls: ['./dialog-alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogAlertComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public archived: boolean) { }
}
